import { ODataHeader, ODataString, ODataDate } from "pbas-vue-components";

export default [
  // new ODataHeader({
  //   title: "headers.contacts.email",
  //   type: new ODataString("Email"),
  //   sortable: true,
  //   visible: true,
  //   searchable: true,
  //   isIdentifier: true,
  //   allowVisibilityChange: false,
  // }),
  new ODataHeader({
    title: "components.allowedusersmanagementtable.header.person_id",
    type: new ODataString("PersonId"),
    sortable: true,
    visible: true,
    searchable: true,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.dob",
    type: new ODataDate("DateOfBirth"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "components.allowedusersmanagementtable.header.date_added",
    type: new ODataDate("DateAdded"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
